export default __webpack_public_path__ + "static/media/Brace Up.21449deb.png";